import type { Enum } from '../generics';

export const AuthProvider = {
  HelloId: 'helloid',
  KidsKonnekt: 'kidskonnekt',
} as const;

export type AuthProviderType = Enum<typeof AuthProvider>;

export interface AppConfig {
  provider: AuthProviderType;
  clientId: string;
  discoveryUrl: string;
  redirectUrl: string;
  apiUrl: string;
  scopes: string;
}
